import { Component, OnInit } from '@angular/core';
import { SidebarService } from './sidebar.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { EcareSecurityService } from '../services/ecare_security_service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  animations: [
    trigger('slide', [
      state('up', style({ height: 0 })),
      state('down', style({ height: '*' })),
      transition('up <=> down', animate(200))
    ])
  ]
})
export class SidebarComponent implements OnInit {
  menus = [];
  access = [];
  carriers = [];
  defaultMenus = [];
  tempMenus = [];
  currentUser: any;
  clientId: any;
  currentUserRoles: any [];
  clientList: any [];
  constructor(public sidebarservice: SidebarService, public securityService: EcareSecurityService,
    public router: Router) {
    this.defaultMenus = sidebarservice.getDefaultMenuList();

   }

  ngOnInit() {
   /* this.currentUser = this.securityService.getUserDetails();
    this.clientId = localStorage.getItem('clientId');
    this.clientList = JSON.parse(localStorage.getItem('clientList'));
    this.currentUserRoles = this.currentUser.permissions[this.clientId];*/

    /*/!*for (let i = 0; i < this.currentUserRoles.length; i++)*!/ {
      for (let j = 0; j < this.defaultMenus.length; j++) {
        this.tempMenus = this.defaultMenus[j].access;
        if (this.tempMenus.indexOf(this.currentUserRoles) >= 0) {
          this.menus.push(this.defaultMenus[j]);
          break;
        }
      }
    }*/
    console.log(this.currentUserRoles)
   /* for (let i = 0; i < this.currentUserRoles.length; i++) {
      for (let j = 0; j < this.defaultMenus.length; j++) {
        if (this.defaultMenus[j].access.indexOf(this.currentUserRoles[i]) >= 0) {
          this.menus.push(this.defaultMenus[j]);
          // break;
        }
      }
    }*/

   this.menus = this.defaultMenus;
    console.log(this.menus);
    this.carriers = this.menus.filter((el, i, a) => i === a.indexOf(el));

//    console.log(this.carriers);
  }

  getSideBarState() {
    return this.sidebarservice.getSidebarState();
  }

  toggle(currentMenu) {
    if (currentMenu.type === 'dropdown') {
      this.menus.forEach(element => {
        if (element === currentMenu) {
          currentMenu.active = !currentMenu.active;
        } else {
          element.active = false;
        }
      });
    }
    if (currentMenu.type === 'simple') {
      this.carriers.forEach(element => {
        if (element === currentMenu) {
          currentMenu.active = !currentMenu.active;
        } else {
          element.active = false;
        }
      });
      console.log('Take me to ' + currentMenu.link);
    }
  }


  getState(currentMenu) {

    if (currentMenu.active) {
      return 'down';
    } else {
      return 'up';
    }
  }

  hasBackgroundImage() {
    return this.sidebarservice.hasBackgroundImage;
  }

  logout() {
    this.securityService.logout();
    this.router.navigate(['/login']);
  }


    /*changeClientSelection(client: any) {
      localStorage.setItem('clientId', client.id);
      window.location.reload();
      //this.router.navigate(['elasticcare/dashboard']);
    }*/
}
